import React from "react";
import * as chatDetailsReducer from "containers/ChatDetails/reducer";
import { Button } from "aible";
import { useDispatch } from "react-redux";
const FetchChatDetailsButton = ({ id, accountId, buttonText, style, isFetchingDetails, updateFetchingId }) => {
    const dispatch = useDispatch();
    const fetchChatMessageDetails = async () => dispatch(chatDetailsReducer.fetchChatMessageDetails(id, accountId));
    const isLoadingId = isFetchingDetails && isFetchingDetails[id] === true;
    return (React.createElement(Button, { onClick: () => {
            if (updateFetchingId) {
                updateFetchingId(id, true);
            }
            fetchChatMessageDetails().then(() => {
                if (updateFetchingId) {
                    updateFetchingId(id, false);
                }
            });
        }, isLoading: isLoadingId, key: "message_details__" + id, isSmall: true, style: { marginRight: "10px" } }, buttonText ? buttonText : "Load Data"));
};
export default FetchChatDetailsButton;
